// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"dacdf216","239":"2f768d6b","401":"4504549e","455":"fc99e4cb","977":"51a1344e"}[chunkId] + ".chunk.js";
};